import { MillisecondsIn1Hour } from 'mini-datetime-utils/lib/dateValues/constants';

/**
 * Method that returns true if session storage is stale.
 * It checks based on the last update time.
 * @param sessionStorageLastUpdateTime the last update time in session storage.
 */
const isEventsSessionStorageStale = sessionStorageLastUpdateTime => {
    // if sessionStorage says its events are usable
    if (sessionStorageLastUpdateTime) {
        // app deciding the usability based on time logic
        const lastUpdateTime = new Date(String(sessionStorageLastUpdateTime)).getTime();
        const currentTime = new Date(new Date().toUTCString()).getTime();
        // if less than 2 hours then use the cache.
        if (currentTime - lastUpdateTime < MillisecondsIn1Hour * 2) {
            return false;
        }
    }
    return true;
};

export default isEventsSessionStorageStale;
